<template>
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog" role="document">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">Notice</h5>
                <!-- <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true" @click="showModal = false">&times;</span>
                </button> -->
              </div>
              <div class="modal-body">
                <p>Your logon has expired. Please logon again to continue.</p>
              </div>
              <div class="modal-footer">
                <!-- <button type="button" class="btn btn-secondary" @click="showModal = false">Close</button> -->
                <button type="button" class="btn btn-primary" @click="hidemodal">Logon again</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
</template>
<script>
export default {
    name: 'modal',
    methods:{
        hidemodal() {
            this.$emit('hidemodal')
      },
    }
}
</script>
<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}
</style>